import React from 'react'
import { localisationMaster } from 'Localisation/Localisation'
import st from './ContractDoc.module.scss'
import { ReactComponent as JpegIcon } from 'components/CRM/UI/icons/jpeg.svg'
import { ReactComponent as PngIcon } from 'components/CRM/UI/icons/png.svg'
import { ReactComponent as JpgIcon } from 'components/CRM/UI/icons/jpg.svg'
import { ReactComponent as TiffIcon } from 'components/CRM/UI/icons/tiff.svg'
import { ReactComponent as WordIcon } from 'components/CRM/UI/icons/word.svg'
import { ReactComponent as Mp3Icon } from 'components/CRM/UI/icons/mp3.svg'
import { ReactComponent as PdfIcon } from 'components/CRM/UI/icons/pdf.svg'
import { ReactComponent as XlsIcon } from 'components/CRM/UI/icons/xls.svg'
import { ReactComponent as XlsxIcon } from 'components/CRM/UI/icons/xlsx.svg'
import { ReactComponent as PptIcon } from 'components/CRM/UI/icons/ppt.svg'
import { ReactComponent as PptxIcon } from 'components/CRM/UI/icons/pptx.svg'
import { ReactComponent as TxtIcon } from 'components/CRM/UI/icons/txt.svg'
import { ReactComponent as ZipIcon } from 'components/CRM/UI/icons/zip.svg'
import { ReactComponent as RarIcon } from 'components/CRM/UI/icons/rar.svg'
import { ReactComponent as Mp4Icon } from 'components/CRM/UI/icons/mp4.svg'
import { ReactComponent as Delete } from 'components/UI/icons/delete-contract.svg'
import { superAxiosRequest } from 'axiosApi'
import swal from 'sweetalert'

export default function ContractDoc(props) {
  const doc = props.doc

  const getFileExtension = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase() // Получаем расширение и приводим его к нижнему регистру
    return ext
  }

  const formatToIcon = {
    png: <PngIcon />,
    jpeg: <JpegIcon />,
    jpg: <JpgIcon />,
    tif: <TiffIcon />,
    doc: <WordIcon />,
    docx: <WordIcon />,
    xls: <XlsIcon />,
    xlsx: <XlsxIcon />,
    pptx: <PptxIcon />,
    ppt: <PptIcon />,
    txt: <TxtIcon />,
    zip: <ZipIcon />,
    rar: <RarIcon />,
    mp3: <Mp3Icon />,
    mpeg: <Mp3Icon />,
    mp4: <Mp4Icon />,
    pdf: <PdfIcon />,
  }

  const renderIcon = (format) => formatToIcon[format] || null
  // const actions = (data) => {
  //   switch (data) {
  //     case 'edit':
  //       const ms = {
  //         link: 'employees/appendix/' + doc.id,
  //         button: 'Save',
  //         title: 'Редактировать документ',
  //         type: 'SelectorAndInput',
  //         active_inputs: ['text', 'textarea'],
  //         is_put: true,
  //
  //         pl_text: 'Имя документа',
  //         name_text: 'title',
  //
  //         pl_textarea: 'Комментарий',
  //         name_textarea: 'description',
  //
  //         func: usersStore.addUserDoc
  //       }
  //       let inner = {
  //         title: doc.title,
  //         description: doc.description,
  //         contract: doc.contract,
  //         employee_id: doc.employee_id
  //       }
  //       modalStore.activity(ms, inner)
  //       break;
  //
  //     default:
  //       break;
  //   }
  // }
  const fileExtension = getFileExtension(doc.file)

  const deleteContract = () => {
    swal({
      title: 'Are you sure?',
      icon: 'warning',
      buttons: [
        localisationMaster('button_2', 'alert'),
        localisationMaster('button_1', 'alert'),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: 'employees/appendix/' + doc.id,
        }
        return superAxiosRequest(apiConf).then(() => props.onDelete(doc.id))
      }
    })
  }

  return (
    <div className={st.contractDocx}>
      <div className={st.gridIcon}>
        <a href={doc.file} download target='_blank' rel='noreferrer'>
          <div className={st.documentIcon}>{renderIcon(fileExtension)}</div>
        </a>
      </div>

      <div className={st.documentItems}>
        <div className={st.documentDesc}>
          <h5>{doc.title}</h5>
          <p>{doc.description}</p>
        </div>
        <div className={st.gridButton}>
          <span onClick={() => deleteContract()} className={st.btn}>
            <Delete />
          </span>
        </div>
      </div>
    </div>
  )
}
